import axios from 'axios';
import { apiEndpoint } from '../urls';
import Cookies from "js-cookie";

const signature = Cookies.get("c_d_token");

const apiClient = axios.create({
  baseURL: `${apiEndpoint.esignBaseUri}/EsignServices`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json, text/plain, */*',
    "signature": signature || Cookies.get("c_d_token"),
  },
  withCredentials: true
});

export async function logUserEvent(event_type, event_name, page, additionalData = {}) {
  try {
    const payload = {
      event_type,
      event_name,
      page,
      ...additionalData
    };
    await apiClient.post('/LogUserEvent', payload);
  } catch (error) {
    console.error('Logging API Error:', error);
  }
}
